import React, { Component } from 'react';
import { toast } from 'react-toastify';

import * as api from '../api';

const HOUR_FIELDS = [
    { key: 'startHour', label: 'Giờ bắt đầu', hint: 'Giờ Việt Nam, 0–23' },
    { key: 'endHour', label: 'Giờ kết thúc', hint: 'Giờ Việt Nam, 0–23' },
];

const BUDGET_FIELDS = [
    { key: 'maxRepliesPerUserPerNight', label: 'Trần trả lời / người / đêm', hint: 'Vượt thì trả lời bằng câu chốt' },
    { key: 'maxGeminiCallsPerDay', label: 'Trần gọi mô hình / đêm', hint: 'Tính chung toàn hệ thống' },
    { key: 'maxReplyChunks', label: 'Số tin tách tối đa', hint: 'Một câu trả lời chia làm mấy tin' },
    { key: 'historyLimit', label: 'Số tin lịch sử', hint: 'Số tin gần nhất đưa vào ngữ cảnh' },
];

/**
 * Cấu hình chatbot: nút bật/tắt, khung giờ, các trần chi phí và kênh Slack.
 */
export default class SettingTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setting: null,
            market: 'VN',
            loading: true,
            saving: false,
            toggling: false,
            dirty: false,
        };
    }

    componentDidMount() {
        this.load();
    }

    notifyChanged = () => {
        if (this.props.onSettingChanged) {
            this.props.onSettingChanged();
        }
    };

    load = () => {
        this.setState({ loading: true });
        api.getSetting(this.state.market)
            .then((setting) => this.setState({ setting: setting || {}, loading: false, dirty: false }))
            .catch(() => {
                this.setState({ loading: false });
                toast.error('Không tải được cấu hình chatbot.');
            });
    };

    handleChange = (key, value) => {
        this.setState((prev) => ({ setting: { ...prev.setting, [key]: value }, dirty: true }));
    };

    handleNumberChange = (key, raw) => {
        this.handleChange(key, raw === '' ? null : Number(raw));
    };

    /**
     * Nút bật/tắt gọi endpoint riêng để có hiệu lực ngay, không phải bấm Lưu.
     */
    handleToggle = () => {
        const { setting } = this.state;
        const next = !(setting && setting.isActive === true);

        if (next && !window.confirm(`Bật chatbot CSKH ${this.state.market}? Người dùng sẽ nhận được câu trả lời tự động ngay.`)) {
            return;
        }

        this.setState({ toggling: true });
        api.toggleSetting(next, this.state.market)
            .then((saved) => {
                this.setState({ setting: saved || {}, toggling: false, dirty: false });
                toast.success(next ? 'Đã bật chatbot CSKH.' : 'Đã tắt chatbot CSKH.');
                this.notifyChanged();
            })
            .catch(() => {
                this.setState({ toggling: false });
                toast.error('Không đổi được trạng thái bật/tắt.');
            });
    };

    validate = () => {
        const { setting } = this.state;
        const errors = [];

        HOUR_FIELDS.forEach(({ key, label }) => {
            const value = setting[key];
            if (value !== null && value !== undefined && (value < 0 || value > 23)) {
                errors.push(`${label} phải trong khoảng 0–23.`);
            }
        });

        if (setting.startHour !== null && setting.startHour !== undefined
            && setting.startHour === setting.endHour) {
            errors.push('Giờ bắt đầu trùng giờ kết thúc thì chatbot không bao giờ chạy.');
        }

        if (setting.confidenceThreshold !== null && setting.confidenceThreshold !== undefined
            && (setting.confidenceThreshold < 0 || setting.confidenceThreshold > 1)) {
            errors.push('Ngưỡng chắc chắn phải trong khoảng 0–1.');
        }

        if (!Number.isInteger(setting.maxUserAgeDays) || setting.maxUserAgeDays < 1) {
            errors.push('Tuổi tài khoản tối đa phải là số nguyên từ 1 ngày trở lên.');
        }

        return errors;
    };

    handleSave = () => {
        const errors = this.validate();
        if (errors.length > 0) {
            errors.forEach((message) => toast.warning(message));
            return;
        }

        this.setState({ saving: true });
        api.updateSetting({ ...this.state.setting, market: this.state.market })
            .then((saved) => {
                this.setState({ setting: saved || {}, saving: false, dirty: false });
                toast.success('Đã lưu cấu hình.');
                this.notifyChanged();
            })
            .catch(() => {
                this.setState({ saving: false });
                toast.error('Không lưu được cấu hình.');
            });
    };

    renderNumberField(field, disabled) {
        const { setting } = this.state;
        return (
            <div className="cs-field" key={field.key}>
                <label>{field.label}</label>
                <input
                    type="number"
                    className="form-control"
                    value={setting[field.key] ?? ''}
                    disabled={disabled}
                    onChange={(e) => this.handleNumberChange(field.key, e.target.value)}
                />
                <small className="cs-hint">{field.hint}</small>
            </div>
        );
    }

    renderPowerCard() {
        const { setting, toggling } = this.state;
        const isActive = setting.isActive === true;

        return (
            <div
                className="cs-card"
                style={{
                    borderColor: isActive ? '#a7f3d0' : '#fecaca',
                    background: isActive ? '#f6fefb' : '#fffafa',
                }}
            >
                <div className="cs-card__body">
                    <div className="cs-filters" style={{ alignItems: 'center' }}>
                        <div style={{ flex: '1 1 340px' }}>
                            <div style={{ fontSize: '16px', fontWeight: 700 }}>
                                Chatbot đang{' '}
                                <span style={{ color: isActive ? 'var(--cs-success)' : 'var(--cs-danger)' }}>
                                    {isActive ? 'BẬT' : 'TẮT'}
                                </span>
                            </div>
                            <div className="cs-hint" style={{ marginTop: '5px' }}>
                                {isActive
                                    ? 'Người dùng nhắn tới tài khoản CSKH sẽ được trả lời tự động trong khung giờ đã đặt.'
                                    : 'Chatbot không trả lời ai cả. Tin nhắn của người dùng vẫn nằm nguyên trong hộp thư.'}
                            </div>
                        </div>
                        <button
                            type="button"
                            className={isActive ? 'btn btn-danger' : 'btn btn-success'}
                            onClick={this.handleToggle}
                            disabled={toggling}
                        >
                            <i className={`fa-solid ${isActive ? 'fa-power-off' : 'fa-play'} mr-1`} />
                            {toggling ? 'Đang xử lý…' : (isActive ? 'Tắt chatbot' : 'Bật chatbot')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { setting, loading, saving, dirty } = this.state;

        if (loading) {
            return <div className="cs-loading">Đang tải cấu hình…</div>;
        }
        if (!setting) {
            return <div className="alert alert-warning">Không có dữ liệu cấu hình.</div>;
        }

        const alwaysOn = setting.alwaysOn === true;

        return (
            <div>
                <div className="cs-field">
                    <label>Thị trường CSKH</label>
                    <select className="form-control" value={this.state.market}
                        onChange={(e) => this.setState({ market: e.target.value, setting: null }, this.load)}>
                        <option value="VN">Việt Nam — iKara & Yokara</option>
                        <option value="PH">Philippines — Yosing Official</option>
                    </select>
                    {this.state.market === 'PH' && <small className="cs-hint">
                        Tắt mặc định. Hãy tạo FAQ và hai prompt tiếng Anh cho Yosing trước khi bật.
                        Giờ hoạt động tính theo Manila.
                    </small>}
                </div>
                {this.renderPowerCard()}

                <div className="cs-split">
                    <div>
                        <div className="cs-card">
                            <div className="cs-card__head">
                                <div>
                                    <h2><i className="fa-solid fa-clock mr-2" />Khung giờ hoạt động</h2>
                                    <div className="cs-card__desc">
                                        Ngoài khung này chatbot im lặng hoàn toàn, tin nhắn nằm chờ nhân viên.
                                    </div>
                                </div>
                            </div>
                            <div className="cs-card__body">
                                <label className="cs-check">
                                    <input
                                        type="checkbox"
                                        checked={alwaysOn}
                                        onChange={(e) => this.handleChange('alwaysOn', e.target.checked)}
                                    />
                                    <span>
                                        <span className="cs-check__text">Chạy cả ngày (bỏ qua khung giờ)</span>
                                        <small className="cs-hint">
                                            Bật cái này thì trần "mỗi đêm" trở thành mỗi ngày tính từ giờ kết
                                            thúc, nên cân nhắc nâng trần trả lời lên.
                                        </small>
                                    </span>
                                </label>

                                <div className="cs-grid cs-grid--2">
                                    {HOUR_FIELDS.map((field) => this.renderNumberField({
                                        ...field,
                                        hint: this.state.market === 'PH' ? 'Giờ Philippines (Manila), 0–23' : field.hint,
                                    }, alwaysOn))}
                                </div>
                            </div>
                        </div>

                        <div className="cs-card">
                            <div className="cs-card__head">
                                <div>
                                    <h2><i className="fa-solid fa-shield-halved mr-2" />Chất lượng câu trả lời</h2>
                                    <div className="cs-card__desc">
                                        Hai hàng rào chống chatbot bịa. Siết chặt thì an toàn hơn nhưng nhiều
                                        câu bị đẩy sang nhân viên hơn.
                                    </div>
                                </div>
                            </div>
                            <div className="cs-card__body">
                                <label className="cs-check">
                                    <input
                                        type="checkbox"
                                        checked={setting.requireFaqReference !== false}
                                        onChange={(e) => this.handleChange('requireFaqReference', e.target.checked)}
                                    />
                                    <span>
                                        <span className="cs-check__text">Bắt buộc trả lời dựa trên FAQ</span>
                                        <small className="cs-hint">
                                            Câu trả lời không nêu được FAQ nào làm căn cứ sẽ bị coi là bịa và
                                            chuyển nhân viên. Nếu câu xã giao ("cảm ơn", "chào bạn") bị chuyển
                                            quá nhiều, hãy thêm FAQ xã giao thay vì tắt luật này.
                                        </small>
                                    </span>
                                </label>

                                <div className="cs-field">
                                    <label>Ngưỡng chắc chắn (0–1)</label>
                                    <input
                                        type="number"
                                        step="0.05"
                                        min="0"
                                        max="1"
                                        className="form-control"
                                        value={setting.confidenceThreshold ?? ''}
                                        onChange={(e) => this.handleChange(
                                            'confidenceThreshold',
                                            e.target.value === '' ? null : Number(e.target.value)
                                        )}
                                    />
                                    <small className="cs-hint">
                                        Dưới ngưỡng thì chuyển nhân viên. Con số này do chính mô hình tự chấm.
                                    </small>
                                </div>

                                <div className="cs-field" style={{ marginBottom: 0 }}>
                                    <label>Model Gemini</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="gemini-2.5-flash-lite"
                                        value={setting.geminiModel ?? ''}
                                        onChange={(e) => this.handleChange('geminiModel', e.target.value)}
                                    />
                                    <small className="cs-hint">
                                        Bỏ trống thì dùng mặc định. Gõ sai tên model thì mọi hội thoại trong
                                        đêm sẽ bị đẩy sang nhân viên — hãy thử ở tab "Nội dung &amp; chạy thử"
                                        trước khi lưu.
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="cs-card">
                            <div className="cs-card__head">
                                <div>
                                    <h2><i className="fa-solid fa-gauge-high mr-2" />Trần chi phí</h2>
                                    <div className="cs-card__desc">
                                        Chạm trần thì chatbot vẫn phản hồi, chỉ là bằng câu chốt sẵn thay vì
                                        gọi mô hình.
                                    </div>
                                </div>
                            </div>
                            <div className="cs-card__body">
                                <div className="cs-grid cs-grid--2">
                                    {BUDGET_FIELDS.map((field) => this.renderNumberField(field, false))}
                                </div>
                            </div>
                        </div>

                        <div className="cs-card">
                            <div className="cs-card__head">
                                <div>
                                    <h2><i className="fa-solid fa-bell mr-2" />An toàn &amp; thông báo</h2>
                                    <div className="cs-card__desc">
                                        Chatbot áp dụng cho ai, chủ đề nào không được đụng vào và báo cho ai khi nó bí.
                                    </div>
                                </div>
                            </div>
                            <div className="cs-card__body">
                                <div className="cs-field">
                                    <label>Tuổi tài khoản tối đa (ngày)</label>
                                    <input
                                        type="number"
                                        min="1"
                                        step="1"
                                        className="form-control"
                                        placeholder="365"
                                        value={setting.maxUserAgeDays ?? ''}
                                        onChange={(e) => this.handleNumberChange(
                                            'maxUserAgeDays',
                                            e.target.value
                                        )}
                                    />
                                    <small className="cs-hint">
                                        Chatbot chỉ trả lời người dùng có tài khoản mới hơn số ngày này.
                                    </small>
                                </div>

                                <div className="cs-field">
                                    <label>Từ khoá nhạy cảm</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder="hoàn tiền,mất icoin,hack,khiếu nại"
                                        value={setting.escalateKeywords ?? ''}
                                        onChange={(e) => this.handleChange('escalateKeywords', e.target.value)}
                                    />
                                    <small className="cs-hint">
                                        Ngăn cách bằng dấu phẩy. Câu hỏi khớp sẽ chuyển nhân viên ngay, không
                                        gọi mô hình. Hệ thống tự bỏ dấu khi so nên "hoàn tiền" bắt được cả
                                        "hoan tien". Tránh từ quá ngắn vì sẽ chặn nhầm nhiều câu.
                                    </small>
                                </div>

                                <div className="cs-field">
                                    <label>Kênh Slack nhận báo</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="C0XXXXXXXXX"
                                        value={setting.slackChannelId ?? ''}
                                        onChange={(e) => this.handleChange('slackChannelId', e.target.value)}
                                    />
                                    <small className="cs-hint">
                                        Bỏ trống thì không gửi Slack. Nhớ mời "Alert Bot" vào kênh, nếu không
                                        tin báo sẽ thất bại trong im lặng.
                                    </small>
                                </div>

                                <div className="cs-field" style={{ marginBottom: 0 }}>
                                    <label>
                                        Danh sách chạy thử
                                        {setting.testUserIds && setting.testUserIds.trim() && (
                                            <span className="cs-badge cs-badge--warning ml-2">đang giới hạn</span>
                                        )}
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder="userId1,userId2"
                                        value={setting.testUserIds ?? ''}
                                        onChange={(e) => this.handleChange('testUserIds', e.target.value)}
                                    />
                                    <small className="cs-hint">
                                        Khác rỗng thì chatbot <b>chỉ</b> trả lời những người này. Để trống
                                        nghĩa là mở cho tất cả người dùng.
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="cs-savebar">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.handleSave}
                        disabled={saving}
                    >
                        <i className="fa-solid fa-floppy-disk mr-1" />
                        {saving ? 'Đang lưu…' : 'Lưu cấu hình'}
                    </button>
                    <button type="button" className="btn btn-outline-secondary" onClick={this.load}>
                        Hoàn tác
                    </button>
                    <span className="cs-savebar__note">
                        {dirty
                            ? 'Có thay đổi chưa lưu. Nút bật/tắt phía trên có hiệu lực ngay, không cần bấm Lưu.'
                            : 'Chưa có thay đổi nào.'}
                    </span>
                </div>
            </div>
        );
    }
}
